module.exports = __webpack_public_path__ + "img/insta-3.bac45e2d.jpg";